export const priceToPenny = (val: number): number => {
  return (val * 1000) / 10;
}
